import { useEffect, useLayoutEffect, useRef, useState } from "react";
import useMainStore from "../stores/mainStore";
import useTextFilesStore from "../stores/textFilesStore";
import { useGetEditor } from "../context/useEditorContext";
import useDataStore from "../stores/dataStore";

function useKeyboardShortcuts() {
    const editor = useGetEditor().editor.current;
    const selectedNoteID = useMainStore((state) => state.data.selectedNoteID);

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            // Save Page
            if (e.ctrlKey && e.key === "s") {
                e.preventDefault();

                useTextFilesStore
                    .getState()
                    .saveContent(selectedNoteID, editor?.getHTML() || "");
            }

            //? Saving here can cause issues if reload is spammed as the content wasn't loaded, but was saved
            // Reload Page
            else if (e.ctrlKey && e.key === "r") {
                const changesMade = Object.values(
                    useDataStore.getState().data.notes
                ).some((note) => note.changesMade);

                if (changesMade) {
                    e.preventDefault();
                }

                // ! Add a confirm dialog here if the user wants to reload the page with unsaved changes
            }
        };

        document.addEventListener("keydown", handleKeyDown);

        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [editor, selectedNoteID]);

    return {};
}

export default useKeyboardShortcuts;
